// extracted by mini-css-extract-plugin
export default {"detailRowStyle":"master-detail-table_detailRowStyle__oCOBL"};